module.exports = __webpack_public_path__ + "static/DSCF8550-4080021982b7fbcccc454d092bc89908.jpg";